












import ProcessedStatsChartDisabled from "@/components/ProcessedStatsChartDisabled.vue";
import { Features } from "@/types/settings";
import { Series } from "@/types/common";
import { Component, Vue, Prop } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component({ components: { ProcessedStatsChartDisabled } })
export default class ProcessedStatsChart extends Vue {
  @Getter("settings/activeCacheFeatures") features!: Features;

  @Prop({ required: true })
  chartID!: string;

  @Prop({ required: false, default: 0 })
  chartIndex!: number;

  @Prop({ required: false, default: false })
  perServer!: boolean;

  @Getter("processedStats/aggregateSeries") aggregateSeries!: (chartID: string, chartIndex: number) => Series;
  @Getter("processedStats/perServerSeries") perServerSeries!: (chartID: string, chartIndex: number) => Series;

  get series() {
    if (this.perServer) {
      return this.perServerSeries(this.chartID, this.chartIndex);
    }
    return this.aggregateSeries(this.chartID, this.chartIndex);
  }
}
